import React from 'react';
import './terms.css';

const CookiePolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1>Cookie Policy</h1>
          <p className="last-updated">Last Updated: December 2023</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. What Are Cookies?</h2>
            <p>
              Cookies are small text files that are stored on your device when you visit our website. 
              They help us provide you with a better experience by remembering your preferences and 
              understanding how you use our site.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. How We Use Cookies</h2>
            <p>Ernestic Fashion uses cookies for several purposes:</p>
            
            <h3>2.1 Essential Cookies</h3>
            <ul>
              <li>Enable basic website functionality</li>
              <li>Allow you to navigate and use key features</li>
              <li>Remember items in your shopping cart</li>
              <li>Maintain your login session</li>
            </ul>

            <h3>2.2 Performance Cookies</h3>
            <ul>
              <li>Help us understand how visitors use our website</li>
              <li>Collect information about page visits and error messages</li>
              <li>Improve website performance and user experience</li>
            </ul>

            <h3>2.3 Functionality Cookies</h3>
            <ul>
              <li>Remember your preferences (language, currency)</li>
              <li>Personalize your experience</li>
              <li>Remember your size preferences and style choices</li>
            </ul>

            <h3>2.4 Marketing Cookies</h3>
            <ul>
              <li>Deliver relevant advertisements</li>
              <li>Track campaign performance</li>
              <li>Limit ad frequency</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Third-Party Cookies</h2>
            <p>We work with third parties that may set cookies on our website:</p>
            <ul>
              <li><strong>Analytics Partners:</strong> Google Analytics, Hotjar</li>
              <li><strong>Advertising Partners:</strong> Facebook, Instagram, Pinterest</li>
              <li><strong>Payment Processors:</strong> Stripe, PayPal</li>
              <li><strong>Social Media:</strong> Social sharing features</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Cookie Duration</h2>
            <ul>
              <li><strong>Session Cookies:</strong> Temporary, expire when you close your browser</li>
              <li><strong>Persistent Cookies:</strong> Remain on your device for set periods</li>
              <li><strong>First-Party Cookies:</strong> Set by Ernestic Fashion</li>
              <li><strong>Third-Party Cookies:</strong> Set by our partners</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Managing Cookies</h2>
            <p>You can control and manage cookies in several ways:</p>
            
            <h3>5.1 Browser Settings</h3>
            <p>
              Most web browsers allow you to control cookies through their settings. You can usually:
            </p>
            <ul>
              <li>Block all cookies</li>
              <li>Block third-party cookies</li>
              <li>Delete existing cookies</li>
              <li>Set preferences for specific websites</li>
            </ul>

            <h3>5.2 Our Cookie Consent Tool</h3>
            <p>
              When you first visit our website, you can choose which types of cookies to accept 
              through our cookie consent banner.
            </p>

            <h3>5.3 Opt-Out Tools</h3>
            <p>
              You can opt-out of certain advertising cookies through industry programs like:
            </p>
            <ul>
              <li>Digital Advertising Alliance (DAA)</li>
              <li>Network Advertising Initiative (NAI)</li>
              <li>European Interactive Digital Advertising Alliance (EDAA)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Impact of Disabling Cookies</h2>
            <p>
              If you choose to disable cookies, some features of our website may not function properly:
            </p>
            <ul>
              <li>You may not be able to stay logged in</li>
              <li>Shopping cart may not remember your items</li>
              <li>Personalized recommendations may not work</li>
              <li>Some website features may be limited</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy to reflect changes in technology, legislation, or 
              our services. We encourage you to review this policy periodically.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Contact Us</h2>
            <p>If you have questions about our use of cookies, please contact:</p>
            <div className="contact-info">
              <p>Email: privacy@ernesticfashion.com</p>
              <p>Phone: +1 (555) 123-ERNESTIC</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;